import { WHY_US_ITEMS } from 'shared/components/NewNavbar/data/SubMenuItems';
import commonStyles from 'shared/components/NewNavbar/styles/NavbarCommon.module.scss';
import { ContainItems } from 'shared/components/NewNavbar/types';
import useTranslation from 'shared/hooks/useTranslation';
import { Divider } from 'ui/shared/atoms/Divider';
import { Spacing } from 'ui/shared/atoms/Spacing';

import { Typography } from '@/ui/shared/molecules/Typography/Typography';

import { LinkInExpandedMenu } from '../LinkInExpandedMenu/LinkInExpandedMenu';

export function WhyUsExpandedContent() {
  const { t } = useTranslation('common');

  return (
    <>
      <Spacing spacing={1} />
      <Typography.Header transform="uppercase" color="#676767" size="xs" tagType="div">
        {t('navbar.whyUs.description')}
      </Typography.Header>
      <Divider />
      <div className={commonStyles.expandedContentGrid}>
        {WHY_US_ITEMS?.map((item: ContainItems) => <LinkInExpandedMenu item={item} key={item.id} />)}
      </div>
    </>
  );
}
